/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import SideBar from './SideBar';
import { BrowserView, MobileView } from 'react-device-detect';

import UserAvatar from "../../components/shared/Buttons/UserAvatar";
import { useSelector } from 'react-redux';
import { IMAGES } from '../../config/assets';


const PageHeader = () => {
  const { classes } = useStyles();
  const loginned = useSelector(state => state.user.loginned);
  const user = useSelector(state => state.user.user);

  return (
    <div className={classes.root}>

      <Grid container >

        <AppBar
          position="static"
          elevation={0}
          className={classes.appBar}
        >
          <Toolbar className={classes.toolbar}>
            <Link
              to={"/"}
            >
              <img src={IMAGES.LOGO} alt="" height="60px" />
            </Link>
            {loginned === true ?
              <UserAvatar user={user} /> : (

                <div className={classes.headerMenu}>
                  <BrowserView>


                    <Link to={"/contact-us"} className={classes.linkBar}
                    ><Typography variant="h3" className={classes.headerMenu}>Contact Us</Typography></Link>
                    <Link to={"/about-us"} className={classes.linkBar}
                    > <Typography variant="h3" className={classes.headerMenu} align="right">About Us</Typography></Link>
                  </BrowserView>
                  <MobileView>
                    <SideBar />
                  </MobileView>
                </div>)}
          </Toolbar>
        </AppBar>
      </Grid>
    </div>
  );

}

const useStyles = makeStyles({ "name": { PageHeader } })(theme => ({
  root: {
    position: "relative",
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%,  ${theme.palette.secondary.main}  35%, ${theme.palette.primary.main}  100%)!important`,


  },

  appBar: {
    width: '100%',
    borderBottom: `1px solid grey`

  },
  toolbar: {
    flexWrap: 'wrap'
  },
  toolbarTitle: {
    color: 'white',
    flexGrow: 1
  },
  headerMenu: {
    marginLeft: "auto",
    display: "inline-block",
    textAlign: "right",
    marginTop: "10px",
    color: "white",
    "&:hover": {
      color: theme.palette.success.main
    }
  },
  linkBar: {
    marginLeft: "30px",
    textAlign: "right",
    marginRight: "30px",
    paddingTop: "30px"
  },
}));
 
export default PageHeader;

